import type { ChildrenProps } from "../types";

export function TableFooter({ children }: ChildrenProps) {
	/** Render */
	return (
		<div className="flex flex-row justify-between items-start gap-2 w-full text-xs">{children}</div>
	);
}
